<template>
  <d-modal
    size="lg"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('shipmentsReports.viewPopup.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table
        v-if="allDataLoaded && items.length"
        class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0 text-center">#</th>
            <th scope="col" class="border-0">{{ $t('shipments.trackingNumber') }}</th>
            <th scope="col" class="border-0 pl-4" style="min-width: 120px;">{{ $t('shipments.status') }}</th>
            <th scope="col" class="border-0" style="min-width: 140px">{{ $t('shipmentsReports.viewPopup.pod') }}</th>
            <th scope="col" class="border-0" style="min-width: 140px">{{ $t('shipmentsReports.viewPopup.invoice') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(shipment, index) of items"
            :key="'shipment-' + index">
            <td class="align-middle pl-4">
              #{{ index + 1 }}
            </td>

            <td class="align-middle">
              <span v-if="shipment.shipment_tracking_number">
                {{ shipment.shipment_tracking_number }}
              </span>
              <span v-else>
                {{ $t('ui.lack') }}
              </span>
            </td>

            <td class="align-middle pl-4">
              <d-badge
                v-if="shipment.shipment_tracking_status"
                :theme="trackingStatusBadgeTheme[shipment.shipment_tracking_status]"
                class="mb-2">
                {{ $t('shipments.trackingStatuses.' + shipment.shipment_tracking_status) }}
              </d-badge>
              <span v-else>
                {{ $t('ui.lack') }}
              </span>
            </td>
            <td class="align-middle">
              <template v-if="shipment.pod_generated">{{ $t('shipmentsReports.viewPopup.podGenerated') }}</template>
              <template v-else>&mdash;</template>
            </td>
            <td class="align-middle">
              <template v-if="shipment.settlements_merged">{{ $t('shipmentsReports.viewPopup.invoiceMerged') }}</template>
              <template v-else>&mdash;</template>
            </td>
          </tr>
        </tbody>
      </table>

      <d-alert
        v-if="allDataLoaded && !items.length"
        show
        theme="warning"
        class="text-center">
        {{ $t('shipmentsReports.viewPopup.noShipments') }}
      </d-alert>

      <d-alert
        v-if="loadError"
        show
        theme="warning"
        class="text-center">
        {{ $t('ui.dataLoadingFailed') }}
      </d-alert>

      <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>
    </d-modal-body>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'shipment-report-view-popup',
  props: {
    reportID: {
      default: 0,
      type: Number
    }
  },
  computed: {
    allDataLoaded () {
      return this.loadedData;
    },
    trackingStatusBadgeTheme () {
      return {
        I: 'warning',
        D: 'success',
        X: 'danger',
        P: 'info',
        M: 'dark'
      };
    },
  },
  data () {
    return {
      items: [],
      // flags
      loadError: false,
      loadedData: false
    };
  },
  mounted () {
    FormUtils.loadItemData(this, {
      endpointBase: '/shipments/reports/item/',
      instanceFields: ['items'],
      loadedKey: 'loadedData',
      errorKey: 'loadError',
      overrideID: this.reportID
    });
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-shipment-report-view-popup');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay-loading {
  left: 0;
  top: 0;
}
</style>
